import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

// Validador personalizado para solo letras y longitud mínima de 3 caracteres
export function nameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const pattern = /^[A-Za-záéíóúÁÉÍÓÚñÑ\s]*$/;
      
      if (value) {
        if (!pattern.test(value)) {
          return { invalidName: true }; // Solo permite letras
        }
        if (value.length < 3) {
          return { minlength: true }; // Longitud mínima de 3 caracteres
        }
      }
      
      return null; // Si pasa todas las validaciones, es válido
    };
  }